module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_round_auburn.0f33eef8.png";